import React, { useState } from 'react';
import { gallery } from '../mock/data';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Kullanıcı henüz tüm resimleri yüklemedi, sadece 1 örnek var
  const displayGallery = gallery.length > 0 ? gallery : [];

  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero Section */}
      <section className="py-16 bg-[var(--dark-card)]">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold font-['Playfair_Display'] gold-gradient-text mb-6">
            Galeri
          </h1>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed">
            Tesisimizden ve hizmetlerimizden görüntüler. Sizi bekleyen huzurlu ortamı keşfedin.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-[var(--dark-bg)]">
        <div className="container mx-auto px-4">
          {displayGallery.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {displayGallery.map((image, index) => (
                <div
                  key={index}
                  className="aspect-square overflow-hidden rounded-xl cursor-pointer card-hover"
                  onClick={() => setSelectedImage(image)}
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <img
                    src={image}
                    alt={`Crocus Hamam Spa - Galeri ${index + 1}`}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="glass rounded-xl p-12 max-w-2xl mx-auto">
                <h3 className="text-2xl font-bold font-['Playfair_Display'] text-[var(--gold)] mb-4">
                  Galeri Çok Yakında
                </h3>
                <p className="text-gray-400">
                  Tesisimizin ve hizmetlerimizin fotoğrafları çok yakında burada olacak.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-in fade-in"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-[var(--gold)] transition-colors duration-300"
            aria-label="Kapat"
          >
            <X size={32} />
          </button>
          <img
            src={selectedImage}
            alt="Crocus Hamam Spa"
            className="max-w-full max-h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;